import { useCallback, useMemo } from 'react';
import adaptSurveyResponse from '@pkg/api/surveys/adaptSurveyResponse';
import useQuery from '@pkg/api/useQuery';
import * as Collections from '@pkg/utils/collections';

/**
 * @param {String} userId
 * @returns {Function}
 */
export default function useUserSurveys(userId) {
  const path = `v1/users/${userId}/surveys`;

  const getSurveys = useCallback(
    async function () {
      return adaptSurveyResponse(await this.get(path));
    },
    [path]
  );

  const result = useQuery(path, getSurveys, {
    enabled: Boolean(userId),
    staleTime: 5 * 60 * 1000, // 5m
  });

  result.surveys = useMemo(() => {
    return Collections.keyBy(result.data?.data ?? [], 'id');
  }, [result.data]);

  return result;
}
